<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div
          class="col-sm-4 form-group"
          :class="{
            'has-error': !outorgadoInfo.descricao || outorgadoInfo.descricao === 'Selecione'
          }"
        >
          <label for="">Tipo Crédito:</label>
          <select
            class="form-control"
            style="padding:unset"
            v-model="outorgadoInfo.descricao"
            @change="onChangeTipoOutorgado"
          >
            <option v-show="false" value="Selecione">Selecione</option>
            <option v-for="(option, i) in outorgadoOptions" :key="i" :value="option.descricao">
              {{ option.descricao }}
            </option>
          </select>
          <p
            class="help-block"
            v-show="!outorgadoInfo.descricao || outorgadoInfo.descricao === 'Selecione'"
          >
            Este campo é obrigatório.
          </p>
        </div>

        <div class="col-sm-2">
          <label for="">Alíq. Crédito:</label>
          <span class="form-control" :disabled="true"> {{ aliqOutorgado }} % </span>
        </div>

        <div class="col-sm-2">
          <label for="">Outorgado: </label>
          <toggle-button
            :value="outorgadoInfo.outorgado"
            @change="outorgadoInfo.outorgado = !outorgadoInfo.outorgado"
            :width="50"
            :color="{ checked: '#00A65A', unchecked: '#DD4B39' }"
            :sync="true"
            :labels="{ checked: 'Sim', unchecked: 'Não' }"
          />
        </div>

        <div class="col-sm-3">
          <div
            class="form-group"
            :class="{
              'has-error': !outorgadoInfo.vigencia || new Date(outorgadoInfo.vigencia) > new Date()
            }"
          >
            <label for="">Vigência:</label>
            <input-data-mes
              v-model="outorgadoInfo.vigencia"
              :editable="true"
              placeholder="Vigência"
            />
            <p class="help-block" v-show="!outorgadoInfo.vigencia">Este campo é obrigatório.</p>
            <p class="help-block" v-show="new Date(outorgadoInfo.vigencia) > new Date()">
              Vigência deve ser menor ou igual a data de Hoje.
            </p>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-sm-12" style="padding-top: 10px">
        <button
          type="button"
          class="btn btn-success btn-sm pull-right"
          title="Salvar crédito outorgado"
          :disabled="emptyFields"
          @click.prevent="save"
        >
          <i class="fa fa-save" /> Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import EmpresaService from '../../services/EmpresaService'
import InputDataMes from '../../components/Inputs/InputDataMes.vue'

export default {
  name: 'modal-outorgado',
  props: {
    outorgadoData: {
      type: Object
    }
  },
  data() {
    return {
      vigencia: '',
      outorgadoOptions: [],
      aliqOutorgado: '',
      outorgadoInfo: {},
      tipoCredito: 0
    }
  },

  mounted() {
    this.outorgadoInfo = this.outorgadoData
    this.getOutorgadoOptions()
  },

  methods: {
    async onChangeTipoOutorgado(event) {
      this.tipoCredito = event.target.selectedIndex
      this.aliqOutorgado = this.outorgadoOptions.find(
        opt => opt.descricao === this.outorgadoInfo.descricao
      ).aliqCredito
    },

    async getOutorgadoOptions() {
      try {
        const { data } = await EmpresaService.getOptionsOutorgado()
        if (!data.length) return
        this.outorgadoOptions = data
        if (this.outorgadoInfo.descricao && this.outorgadoInfo.descricao !== 'Selecione') {
          const findedOption = this.outorgadoOptions.find(
            opt => opt.descricao === this.outorgadoInfo.descricao
          )
          this.aliqOutorgado = findedOption.aliqCredito
          this.tipoCredito = findedOption.tipoCredito
        }
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível buscar as opções de crédito outorgado.')
        console.error(e)
      }
    },

    async save() {
      try {
        await EmpresaService.insertCreditoOutorgado(this.savePayload)
        this.$messages.success().toast('Crédito outorgado atualizado com sucesso.')
        this.$emit('on-save', true)
      } catch (e) {
        this.$messages
          .error(e.message || e.data.message)
          .toast('Não foi possível atualizar o crédito outorgado.')
        console.error(e)
      }
    }
  },

  components: {
    InputDataMes
  },

  computed: {
    empresaSelecionada() {
      return this.$store.getters.getCompany
    },

    savePayload() {
      return {
        idEmpresa: this.empresaSelecionada.id,
        tipoCredito: this.tipoCredito,
        vigencia: this.outorgadoInfo.vigencia,
        outorgado: this.outorgadoInfo.outorgado ? this.outorgadoInfo.outorgado : false
      }
    },

    emptyFields() {
      return (
        !this.tipoCredito ||
        !this.outorgadoInfo.vigencia || new Date(`${this.outorgadoInfo.vigencia}`) > new Date()
      )
    }
  },

  watch: {
    outorgadoInfo(vl) {
      if (!vl.descricao) this.outorgadoInfo.descricao = 'Selecione'
    }
  }
}
</script>

<style lang="css">
.space-around {
  display: flex;
  justify-content: space-around;
}
.input-number::-webkit-outer-spin-button,
.input-number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
